import React from 'react';
import styled from 'react-emotion';
import { EMAIL_ADDRESS, XING_PROFILE } from '@sthzg/sthzgnet-base';

const Wrapper = styled.p`
  text-align: center;
`;

const ContactOpts = () => (
  <Wrapper>
    Available on <a href={XING_PROFILE}>Xing</a> or just drop me an{' '}
    <a href={`mailto:${EMAIL_ADDRESS}`}>E-Mail!</a>
  </Wrapper>
);

export default ContactOpts;



// WEBPACK FOOTER //
// ../sthzgnet-branding/lib/ContactOpts/ContactOpts.jsx